import Page0 from '@Resources/game/guides/welcome/vr/page0.png';
import Page1 from '@Resources/game/guides/welcome/vr/page1.png';
import Page2 from '@Resources/game/guides/welcome/vr/page2.png';
import Page3 from '@Resources/game/guides/welcome/vr/page3.png';
import Page4 from '@Resources/game/guides/welcome/vr/page4.png';
import Page5 from '@Resources/game/guides/welcome/vr/page5.png';


export default {
  backgroundOverride: '#F0F0F0',
  marginOverride: '0 0 60px 0',
  forceFullPageContent: true,
  slides: [
    {
      content: [
        {
          type: 'image',
          value: Page0,
          fullPage: true
        },
      ],
    },
    {
      content: [
        {
          type: 'image',
          value: Page1,
          fullPage: true
        },
      ],
    },
    {
      content: [
      {
          type: 'image',
          value: Page2,
          fullPage: true
        },
      ],
    },
    {
      content: [
        {
          type: 'image',
          value: Page3,
          fullPage: true
        },
      ],
    },
    {
      content: [
        {
          type: 'image',
          value: Page4,
          fullPage: true
        },
      ],
    },
    {
      content: [
        {
          type: 'image',
          value: Page5,
          fullPage: true
        },
      ],
    }
  ],
};
